import API from "../../lib/api";
import { addMessage } from "../messages/actions";
import { MessageTypes } from "../../lib/types";
import { defaultErrorMessage } from "../../lib/constants";

/**
 * Query locations based on the zip code saved in state and save the result as a new bot message.
 */
export const queryLocations = () => async (dispatch) => {
  try {
    const locationsData = await dispatch(API.findLocations());
    dispatch(
      addMessage({
        type: MessageTypes.LOCATIONS_MESSAGE,
        locationsData,
      })
    );
  } catch (e) {
    console.log(e);
    dispatch(
      addMessage({
        type: MessageTypes.ERROR_MESSAGE,
        text: defaultErrorMessage,
        answers: [
          {
            action: 1,
            text: "Back to Start",
          },
        ],
      })
    );
  }
};
